module.exports = __webpack_public_path__ + "src/assets/games/3/beijing3.jpg";